import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({ transparent = false }) => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) =>
    location.pathname === path ? 'active' : '';

  // auto close menu after route change (VERY IMPORTANT)
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={
        transparent
          ? 'position-absolute w-100 sm-position-relative transparent-header'
          : 'fixedHeader'
      }
    >
      <div className="navbar-default">
        <div className="container lg-container">
          <div className="row align-items-center">
            <div className="col-12">
              <nav className="navbar navbar-expand-lg navbar-light p-0 d-flex align-items-center">
                
                {/* Logo */}
                <div className="navbar-header navbar-header-custom">
                  <Link
                    to="/"
                    className={`navbar-brand ${
                      transparent ? 'inner-logo' : ''
                    }`}
                  >
                    <img
                      id="logo"
                      src={
                        transparent
                          ? '/img/logos/logo-white.png'
                          : '/img/logos/logo.png'
                      }
                      alt="Source-ERP"
                    />
                  </Link>
                </div>

                {/* Mobile Toggle */}
                <button
                  className="navbar-toggler"
                  onClick={() => setMenuOpen(!menuOpen)}
                  type="button"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>

                {/* Menu */}
                <ul
                  className={`navbar-nav ms-auto ${
                    menuOpen ? 'show-menu' : ''
                  }`}
                  id="nav"
                >
                  <li className={isActive('/')}>
                    <Link to="/">Home</Link>
                  </li>
                  <li className={isActive('/about')}>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li className={isActive('/services')}>
                    <Link to="/services">Services</Link>
                  </li>
                  <li className={isActive('/contact')}>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                </ul>

              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
